import { useEffect, useState } from 'react';
import Select from 'react-select';

import Spinner from '../../../../reusable/spinner/spinner.component';
import Client from '../../../../../tools/client';

import {
  FieldSection,
  FieldGroup,
  Label,
  Description,
  ButtonRow,
  Button
} from '../../configuration-sections.styles';

const client = new Client();

const ThemeConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [themes, setThemes] = useState([]);
  const [selectedTheme, setSelectedTheme] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const [configRes, themesRes] = await Promise.all([
        client.setup(),
        client.getThemes()
      ]);

      const themeId = configRes.configuration?.app?.theme?.id || '';
      const allThemes = themesRes.rows || [];

      setThemes(allThemes);

      const found = allThemes.find(t => String(t.id) === String(themeId));
      if (found) {
        setSelectedTheme({ value: found.id, label: found.name || `Theme ${found.id}` });
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  const handleChange = (option) => {
    setSelectedTheme(option);
  };

  const handleSave = async () => {
    await client.updateConfigurationByKey('app.theme.id', {
      value: selectedTheme?.value || ''
    });
    setEditing(false);
  };

  if (loading) return <Spinner />;

  return (
    <FieldSection>
      <FieldGroup>
        <Label htmlFor="themeId">Theme</Label>
        <Description>
          Choose the active theme for the storefront. Themes define the look and feel of the site, including layout, colors, and typography.
        </Description>
        <Select
          name="themeId"
          value={selectedTheme}
          onChange={handleChange}
          options={themes.map(theme => ({
            value: theme.id,
            label: theme.name || `Theme ${theme.id}`
          }))}
          isDisabled={!editing}
        />
      </FieldGroup>

      <ButtonRow>
        {editing ? (
          <>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
            <Button primary onClick={handleSave}>Save</Button>
          </>
        ) : (
          <Button primary onClick={() => setEditing(true)}>Edit</Button>
        )}
      </ButtonRow>
    </FieldSection>
  );
};

export default ThemeConfigurationDisplay;